import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * MUI components
 */
import Paper from '@mui/material/Paper';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CarCrashIcon from '@mui/icons-material/CarCrash';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Badge from '@mui/material/Badge';

/**
 * Hooks
 */
import useToken from '../hooks/useToken';
import { useUserUnreadNotifications } from '../hooks/Notifications/useUserUnreadNotifications';

/**
 * Routes
 * NOTE: Must be in the same order as bottom navigation menu items.
 */
const ROUTES = ['/', '/notifications', '/vehicles/alerts', '/profile'];

const BottomNav = () => {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    const { token, setToken } = useToken();
    const { unreaded, loading, error } = useUserUnreadNotifications(token);

    // FIXME: Implement this hook and fetch the number of unreaded vehicle alerts.
    const [vehicleAlertsUnreaded, setVehicleAlertsUnreaded] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        navigate(ROUTES[newValue] ?? '/');
    };

    useEffect(() => {
        const index = ROUTES.indexOf(location.pathname);
        setValue(index !== -1 ? index : 0);
    }, [location.pathname]);

    return (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }} elevation={3}>
            <BottomNavigation value={value} onChange={handleChange} showLabels>
                <BottomNavigationAction label={t('My works')} icon={<RestoreIcon />} />
                <BottomNavigationAction label={t('Notifications')}
                    icon={
                        <Badge badgeContent={unreaded} color="error">
                            <FavoriteIcon />
                        </Badge>
                    }
                />
                <BottomNavigationAction label={t('Vehicles')}
                    icon={
                        <Badge badgeContent={vehicleAlertsUnreaded} color="error">
                            <CarCrashIcon />
                        </Badge>
                    }
                />
                <BottomNavigationAction label={t('Profile')} icon={<LocationOnIcon />} />
            </BottomNavigation>
        </Paper>
    );
};

export default BottomNav;
